import React from 'react'
import { useStore, useDispatch, useSelector } from 'react-redux';
import { unset } from 'global/lib/lodash';
import { SET_HARD_DATA } from 'redux/actions/types';

export const useData = props => {
  const data = useSelector(state => state.data);
  const store = useStore();
  const dispatch = useDispatch();

  const destroyCache = _caches => {
    const caches = !_caches ? null : Array.isArray(_caches) ? _caches : [_caches];

    const curData = store.getState().data;
    const newData = { ...curData };

    Object.keys(curData).map(k => {
      if (k.includes('http')) {
        const hasMatch = !caches ? true : !!caches.find(c => k.includes(c));
        if (hasMatch) {
          unset(newData, k);
        }
      }
    })

    dispatch({ type: SET_HARD_DATA, data: { ...newData } });
  }

  return {
    data,
    destroyCache,
  }
}